import React, { useContext, useEffect } from "react";
import { cloneDeep } from "lodash";
import { Accordion, Card, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CareUserContext } from "./provider/careUserContext";
import noImage from "../../../assets/images/no-image.png";
import CustomTooltip from "../../../Components/Tooltip/CustomTooltip";
import Switch from "../../../Components/CommonSwitch/Switch";
import { deactivateRowInGroupAction } from "./store/UserInstruction.action";

export default function CommonAccordion(prop) {
  const { item, index, accordianKey, handleExpandKey } = prop;
  const { t } = useTranslation("common");
  const { t: tCare } = useTranslation("modules/care-user-instructions");
  const dispatch = useDispatch();
  const { state, setState, handleDeleteTabData, handleRefresh, CareAddEditAccess } = useContext(CareUserContext);
  const { groupId } = useParams();

  const checkAccodionActiveState = (str) => {
    return state?.accordianArray?.includes(str);
  };

  const handleClickToggle = async (eventKey) => {
    const copyaccodionArray = cloneDeep(state?.accordianArray);
    const accIndex = copyaccodionArray.indexOf(eventKey);
    if (!groupId) {
      setState((prevState) => ({
        ...prevState,
        expandTabId: item?._id,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        expandTabId: '',
      }));
    }

    if (accIndex >= 0) {
      copyaccodionArray.splice(accIndex, 1);
    } else {
      copyaccodionArray.push(eventKey);
    }
    setState((prevState) => ({
      ...prevState,
      accordianArray: copyaccodionArray,
    }));
  };

  const onSwitchChange = (e, index) => {
    const value = e.target.checked;
    const updatedTabs = cloneDeep(state?.careGroupDetails?.tabs);
    updatedTabs[index].showTab = value;
    setState((prevState) => ({
      ...prevState,
      careGroupDetails: {
        ...prevState.careGroupDetails,
        tabs: updatedTabs,
      },
    }));
  };
  // Your existing function...
  const handleSelectAll = () => {
    const newIsSelectAll = !state.isSelectGroup[item.tabId]; // Toggle the specific tab's isSelectAll

    // Get unique rowIds from tabDetails
    const uniqueRowIds = [...new Set(item?.tabDetails?.map((detail) => detail?.rowId))];

    // If Select All is toggled on, add all unique rowIds to selectedIdArray, otherwise clear it
    const updatedSelectedIds = newIsSelectAll ? uniqueRowIds : [];

    // Update the state with the new selectedIdArray and isSelectAll status for the specific tabId
    setState((prevState) => ({
      ...prevState,
      isSelectGroup: {
        ...prevState.isSelectGroup,
        [item.tabId]: newIsSelectAll, // Set isSelectAll for this tabId
      },
      selectedIdArray: newIsSelectAll ? updatedSelectedIds : prevState.selectedIdArray.filter((id) => !uniqueRowIds.includes(id)), // Adjust the selectedIdArray accordingly
    }));
  };

  const handleRowCheckboxChange = (rowId) => {
    // Log current selectedIdArray
    // Handle the checkbox change for unique rowId
    const updatedSelectedIds = state.selectedIdArray.includes(rowId)
      ? state.selectedIdArray.filter((id) => id !== rowId) // Remove rowId if it's already selected
      : [...state.selectedIdArray, rowId]; // Add rowId if it's not selected

    // Get unique rowIds from tabDetails
    const uniqueRowIds = [...new Set(item?.tabDetails.map((detail) => detail.rowId))];

    // Check if all unique rowIds are selected
    const allSelected = uniqueRowIds.every((uniqueRowId) => updatedSelectedIds.includes(uniqueRowId));
    // Update state with the new selectedIdArray and isSelectAll status for the specific tabId
    setState((prevState) => ({
      ...prevState,
      selectedIdArray: updatedSelectedIds,
      isSelectGroup: {
        ...prevState.isSelectGroup,
        [item.tabId]: allSelected, // Set isSelectAll for this tabId
      },
    }));
  };

  const handleDeactivateToggle = async (rowId, isActive) => {
    if (!isActive) return;
    const res = await dispatch(deactivateRowInGroupAction(groupId, rowId, t));
    if (res?.success) {
      await handleRefresh(groupId);
    }
  };

  useEffect(() => {
    if (state?.updatedTabDetails?.length > 0 && state.careGroupDetails.name && groupId) {
      const updatedTabs = cloneDeep(state.careGroupDetails);
      updatedTabs.tabs.forEach((ele) => {
        if (ele?.tabId === state?.updatedTabDetails[0]?.tabId) {
          state?.updatedTabDetails.forEach((newDetail) => {
            if (!Array.isArray(ele.tabDetails)) {
              ele.tabDetails = [];
            }
            const existingDetailIndices = ele?.tabDetails.map((detail, ind) => (detail?._id === newDetail._id ? ind : -1)).filter((ind) => ind !== -1);
            if (existingDetailIndices.length > 0) {
              existingDetailIndices.forEach((ind) => {
                ele.tabDetails[ind] = newDetail;
              });
            } else {
              ele.tabDetails.push(newDetail);
            }
          });
        }
      });

      setState((prevState) => ({
        ...prevState,
        careGroupDetails: updatedTabs,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId, state?.updatedTabDetails]);

  const setImage = (image) => {
    let imagePath = '';
    if (image) {
      imagePath = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };

  const renderValue = (value, column) => {
    if (column?.columnDetails?.columnType?.key === 'Image') {
      return <img src={setImage(value?.image)} alt={column?.name} width="70px" height="70px" />;
    }
    if (column?.columnDetails?.columnType?.key === 'Status') {
      return (
        <div className="background-td-color w-100" style={{ backgroundColor: column?.columnDetails?.status?.colourHexCode }}>
          <span>{column?.columnDetails?.status?.colourName}</span>
        </div>
      );
    }
    if (column?.columnDetails?.columnType?.key === 'Radio_button' || column?.columnDetails?.columnType?.key === 'Dropdown') {
      return value?.name || '';
    }
    if (column?.columnDetails?.columnType?.key === 'Multi_select_Dropdown') {
      return value?.map((val) => val?.label).join(', ') || '';
    }
    return !value || typeof value === 'object' ? '' : value;
  };

  return (
    <div className="collapse-card common-accordion ">
      <Accordion className=" " key={accordianKey || `items_${index}`} activeKey={checkAccodionActiveState(handleExpandKey)}>
        <Card className="flex-fill">
          <Card.Header>
            <div className="custom-control d-inline-flex design-switch pl-0">
              <input
                type="checkbox"
                className="form-check-input"
                id={`items_check_${index}`}
                name={`items_check_${index}`}
                onChange={(e) => onSwitchChange(e, index)}
                checked={item?.showTab}
              />
              <label className="accordion-title mb-0" htmlFor={`items_check_${index}`}>
                {item?.tabName}
              </label>
            </div>
            <CustomTooltip tooltipText={t('PIM_MODULE.TAB.DELETE')}>
              <button
                aria-label="multi-delete"
                type="button"
                disabled={!item.tabDetails || item?.tabDetails?.length === 0}
                className="btn d-inline-flex delete-grp-btn"
                onClick={() => handleDeleteTabData('', true)}
              >
                <i className="icon-Delete f-20" />
              </button>
            </CustomTooltip>
            <Accordion.Toggle
              className="btn-toggle d-inline-flex accordion-toggle-icon"
              as={Button}
              variant="link"
              disabled={!item?.showTab}
              eventKey={checkAccodionActiveState(handleExpandKey)}
              onClick={() => handleClickToggle(handleExpandKey)}
            >
              <i className={checkAccodionActiveState(handleExpandKey) ? 'icon-new-down-arrow-icon  down-arrow-data inverse' : 'icon-new-down-arrow-icon'} />
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey={checkAccodionActiveState(handleExpandKey)}>
            <Card.Body className="add-border-top">
              <div className="table-responsive">
                <table id="care-user-table" className="table common-custom-table">
                  {item?.tabColumns?.length > 0 && (
                    <thead>
                      <tr>
                        <th aria-label="header" className="w-50px">
                          <div className="common-checkbox margin-auto">
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={state?.isSelectGroup[item.tabId] || false} // Check if isSelectAll for this tabId is true
                              name={`check_${item?.tabId}`}
                              id={`check_${item?.tabId}`}
                              disabled={item.tabDetails && item.tabDetails.length === 0}
                            />
                            <label htmlFor={`check_${item?.tabId}`} className="chklabel">
                              <span />
                            </label>
                          </div>
                        </th>

                        {item?.tabColumns
                          ?.sort((a, b) => a.sequence - b.sequence) // Sort the columns based on the sequence/order
                          .map((column, columnIndex) => (
                            <th
                              key={column?._id}
                              className={`w-${column?.name === 'Image' ? '100px' : '150px'} ${
                                item?.tabColumns?.length > 6 && item.tabDetails?.length > 0 && columnIndex === 0 ? 'first-fix-col' : ''
                              }`}
                            >
                              {column?.name}
                            </th>
                          ))}

                        <th aria-label="action" className={item?.tabColumns.length > 6 && item?.tabDetails?.length > 0 ? 'last-fix-col w-50px' : 'w-50px'} />
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {item?.tabDetails?.length > 0 ? (
                      [...new Set(item?.tabDetails.map((detail) => detail.rowId))].map((rowId) => {
                        const rowDetails = item?.tabDetails?.filter((detail) => detail.rowId === rowId);
                        return (
                          <tr key={rowId}>
                            <td>
                              <div className="common-checkbox margin-auto">
                                <input
                                  type="checkbox"
                                  checked={state?.selectedIdArray?.includes(rowId)}
                                  onChange={() => handleRowCheckboxChange(rowId)}
                                  name={`check_${rowId}`}
                                  id={`check_${rowId}`}
                                />
                                <label htmlFor={`check_${rowId}`} className="chklabel">
                                  <span />
                                </label>
                              </div>
                            </td>
                            {item?.tabColumns?.map((column, columnIndex) => {
                              const data = rowDetails?.find((detail) => detail.columnId === column?._id);
                              return (
                                <td key={column?._id} className={`${item?.tabColumns.length > 6 && columnIndex === 0 ? 'first-fix-col' : ''}`}>
                                  {renderValue(data?.value, column)}
                                </td>
                              );
                            })}
                            <td className={item?.tabColumns?.length > 6 ? "last-fix-col text-right" : "text-right"}>
                              {groupId && CareAddEditAccess && (
                                <CustomTooltip placement="top" tooltipText={tCare("DEACTIVATE_TOOLTIP")}>
                                  <span className="d-inline-block align-middle mr-2">
                                    <span className="sr-only">{tCare("DEACTIVATE_BUTTON")}</span>
                                    <Switch
                                      id={`deactivate_${rowId}`}
                                      name={`deactivate_${rowId}`}
                                      checked={rowDetails[0]?.isActive !== false}
                                      handleChange={() => handleDeactivateToggle(rowId, rowDetails[0]?.isActive !== false)}
                                    />
                                  </span>
                                </CustomTooltip>
                              )}
                              <CustomTooltip placement="top" tooltipText={t("PIM_MODULE.TAB.DELETE")}>
                                <button aria-label="delete" type="button" className="btn" onClick={() => handleDeleteTabData(rowId, false)}>
                                  <i className="icon-Delete f-20" />
                                </button>
                              </CustomTooltip>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={(item?.tabColumns?.length || 0) + 2} className="text-center">
                          {t('PRODUCT_LIST.ALL_INFORMATION.NO_DATA_AVAILBLE')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}
